import type { RefAttributes } from "react";
import type {
  VerificationInputProps,
} from "react-verification-input";
import VerificationInput from "react-verification-input";
import style from "./Input.module.css";

export const InputCode = (
  props: VerificationInputProps & RefAttributes<HTMLInputElement>
) => {
  return (
    <div className={style.codeContainer}>
      <VerificationInput
        {...props}
        inputProps={{
          className: style.inputCodeField,
          ...props.inputProps,
        }}
        containerProps={{
          className: style.inputCode,
        }}
        classNames={{
          character: style.inputCharacter,
          characterInactive: style.inputCharacter,
          characterSelected: style.inputCharacter,
        }}
      />
    </div>
  );
};
